import React from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import {
  PageListBean,
  RestVendorListRequest,
  VendorSearchCriteria,
} from "../ds/ds.js";
import { LookupHandler, LookupResultDetails } from "../ds/lookup_ds.js";
import { Eraser, TickIcon } from "../gui_components/Icons.js";
import { InputTextbox, ShowError } from "../gui_components/UIComponents.js";
import { isEmpty, isEmptyString } from "../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { VendorService } from "../services/VendorService.js";
import { AppContext } from "../AppContext.js";
import { ModuleUtils } from "../modules/ModuleUtils.js";
export class VendorLookupHandler extends LookupHandler {
  static contextType = AppContext;
  constructor(companyCode, attribute_name) {
    super();
    this.attribute_name = attribute_name;
    this.lookupTitle = attribute_name + " Lookup";
    this.companyCode = companyCode;
    let resetCriteria = new VendorSearchCriteria();
    resetCriteria.companyCode = companyCode;
    this.resetCriteria = resetCriteria;
    let vendorLookupCriteria = new VendorSearchCriteria();
    vendorLookupCriteria.companyCode = this.companyCode;
    let newCriteria = new VendorSearchCriteria();
    newCriteria.companyCode = companyCode;
    this.newCriteria = newCriteria;
    let lookupCriteriaView = VendorLookupCriteraHandler(
      companyCode,
      vendorLookupCriteria
    );
    let lookupDataCallback = function (
      lookup_dialog,
      page_number,
      searchCriteria,
      filterText
    ) {
      this.fetchDataFromService(
        lookup_dialog,
        page_number,
        searchCriteria,
        filterText
      );
    };
    this.setDetails(
      lookupDataCallback,
      vendorLookupCriteria,
      lookupCriteriaView
    );
    this.initColumns();
  }
  initColumns() {
    this.addColumnDefinition(this.attribute_name, "code", 0, true); //1
    this.addColumnDefinition(
      this.attribute_name + " Name",
      "description",
      0,
      false
    ); //1
    this.addColumnDefinition("Currency", "currencyCode", 0, false); //3
    this.addColumnDefinition("vendorCategory", "vendorCategoryCode", 0, false); //3
    this.addColumnDefinition("BuyingTerms", "buyingTermsCode", 0, false); //3
    this.addColumnDefinition("shipVia", "shipViaCode", 0, false); //3
    this.addColumnDefinition("FOBCity", "fOBCity", 0, false); //3
    this.addColumnDefinition("Incoterm", "incoterm", 0, false); //3
    this.addColumnDefinition("Phone", "address.phoneNumber1", 0, false); //2
  }
  loadVendorList = (lookup_dialog, pageNumber, searchCriteria) => {
    let cust_criteria = new VendorSearchCriteria(); //To be fetched from CriteriaHandler
    cust_criteria.companyCode = this.companyCode;
    if (searchCriteria !== undefined && searchCriteria !== null) {
      cust_criteria.vendorCode = searchCriteria.vendorCode;
      cust_criteria.vendorCodeContains = searchCriteria.vendorCodeContains;
      cust_criteria.vendorCodeStartsWith = searchCriteria.vendorCodeStartsWith;
      cust_criteria.vendorNameContains = searchCriteria.vendorNameContains;
      cust_criteria.buyingTermsCode = searchCriteria.buyingTermsCode;
      cust_criteria.shipViaCode = searchCriteria.shipViaCode;
      cust_criteria.fOBCity = searchCriteria.fOBCity;
      cust_criteria.incoterm = searchCriteria.incoterm;
      cust_criteria.vendorCategoryCode = searchCriteria.vendorCategoryCode;
      cust_criteria.status = searchCriteria.status;
    }
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 50; //TODO --> Fetch from Config
    cust_pageList.currentPage = pageNumber;
    cust_pageList.pageNumber = pageNumber;
    let ven_requestInput = new RestVendorListRequest();
    ven_requestInput.pageInput = cust_pageList;
    ven_requestInput.searchCriteria = cust_criteria;
    VendorService.getVendorPageList(
      ven_requestInput,
      (response) => this.loadVendorListResponse(response, lookup_dialog),
      this.loadVendorListError
    );
  };
  loadVendorListResponse = (response, lookup_dialog) => {
    let vendorList = [];
    let totalCount = 0;
    let currentPageNumber = 0;
    let pageSize = 0;
    if (
      response.data.vendorPageList != null &&
      response.data.vendorPageList.vendors !== null
    ) {
      vendorList = response.data.vendorPageList.vendors;
      totalCount = response.data.vendorPageList.totalCount;
      currentPageNumber = response.data.vendorPageList.currentPage;
      pageSize = response.data.vendorPageList.pageSize;
    }
    let lookup_result_details = new LookupResultDetails();
    lookup_result_details.pageData = vendorList;
    let total_count = 0;
    if (this.lookup_data != null) {
      total_count = this.lookup_data.length;
    }
    lookup_result_details.totalRecordsCount = totalCount;
    lookup_result_details.currentPageNumber = currentPageNumber;
    lookup_result_details.pageSize = pageSize;
    lookup_result_details.criteriaDisplayString = ""; //TODO
    lookup_dialog.updateResultCallBack(lookup_result_details);
  };
  loadVendorListError = (error) => {
    ShowError("Error : " + error);
  };
  fetchDataFromService(lookup_dialog, pageNumber, searchCriteria, filterText) {
    let search = { ...searchCriteria };
    if (search != null && search != "unDefined") {
      // if (isEmptyString(search.vendorCodeContains)) {
      if (!isEmptyString(filterText)) {
        search.vendorCodeContains = filterText;
        this.searchCriteria = new VendorSearchCriteria();
      }
    }
    if (lookup_dialog != null) {
      this.loadVendorList(lookup_dialog, pageNumber, search);
    }
  }
}
const VendorLookupCriteraHandler = (companyCode, vendorLookupCriteria) => {
  return class extends React.Component {
    static contextType = AppContext;
    constructor(props) {
      super(props);
      this.state = {
        searchCriteria: new VendorSearchCriteria(),
        fOBCities: new Array(),
        incoTerms: new Array(),
        shipViaCodes: new Array(),
        vendorTerms: new Array(),
        shipViaPageListForAutoCompleteList: new Array(),
        showAutoCompleteShipViaList: true,
        fobPageListForAutoCompleteList: new Array(),
        showAutoCompleteFOBList: true,
        incoTermPageListForAutoCompleteList: new Array(),
        showAutoCompleteIncoTermList: true,
        showAutoCompleteVendorTermList: true,
        vendorTermPageListForAutoCompleteList: new Array(),
      };
      this.criteriaLookupHandler = React.createRef();
      this.focusRef = React.createRef();
    }
    componentDidMount() {
      const { appData } = this.context;
      const { cache } = appData;
      this.cache = cache;
      let searchCriteria = this.state.searchCriteria;
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
      this.loadCacheDetails();
      this.initLookupHandlers();
    }
    componentDidUpdate() {}
    loadCacheDetails = () => {
      // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
      const attribute_cache = { ...this.cache };
      this.state.vendorTerms = [];
      let vendorTerms = attribute_cache.vendorTerms;
      let vendorTerms_temp=[];
      vendorTerms.map((line) => {
       vendorTerms_temp.push(line);
        this.state.vendorTerms=ModuleUtils.isActiveAttribute(vendorTerms_temp);
      });
      this.state.shipViaCodes = [];
      let shipViaCodes = attribute_cache.shipVias;
      let shipViaCodes_temp=[];
      shipViaCodes.map((line) => {
        shipViaCodes_temp.push(line);
        this.state.shipViaCodes=ModuleUtils.isActiveAttribute(shipViaCodes_temp);
      });
      this.state.fOBCities = [];
      let fOBCities = attribute_cache.fOBCities;
       let fOBCities_temp=[];
      fOBCities.map((line) => {
        fOBCities_temp.push(line);
        this.state.fOBCities=ModuleUtils.isActiveAttribute(fOBCities_temp);
      });
      this.state.incoTerms = [];
      let incoTerms = attribute_cache.incoTerms;
      let incoTerms_temp=[];
      incoTerms.map((line) => {
        incoTerms_temp.push(line);
        this.state.incoTerms=ModuleUtils.isActiveAttribute(incoTerms_temp);
      });
    };
    initLookupHandlers = () => {
      let fobCityLookupHandler = new GenericAttributeLookupHandler(
        this.state.fOBCities,
        "FobCity"
      );
      this.setState({ fobCityLookupHandler: fobCityLookupHandler });

      let vendorTermLookupHandler = new GenericAttributeLookupHandler(
        this.state.vendorTerms,
        "VendorTerm"
      );
      this.setState({ vendorTermLookupHandler: vendorTermLookupHandler });
      let shipViaLookupHandler = new GenericAttributeLookupHandler(
        this.state.shipViaCodes,
        "ShipVia"
      );
      this.setState({ shipViaLookupHandler: shipViaLookupHandler });
      let incoTermLookupHandler = new GenericAttributeLookupHandler(
        this.state.incoTerms,
        "IncoTerm"
      );
      this.setState({ incoTermLookupHandler: incoTermLookupHandler });
    };
    continueButtonClick = () => {
      this.props.searchCriteriaCallBack(this.state.searchCriteria);
    };
    onChange = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({ searchCriteria: temp_searchCriteria });
    };
    clearCriteria = () => {
      let searchCriteria = new VendorSearchCriteria();
      searchCriteria.companyCode = companyCode;
      this.setState({ searchCriteria: searchCriteria });
      if (this.focusRef.current) this.focusRef.current.focus();
    };
    onContainerKeyDown = (e) => {
      if (e.ctrlKey && e.keyCode == "191") {
        this.continueButtonClick();
      }
    };
    onShipViaChange = (e) => {
      let shipViaCode = e.target.value;
      this.state.showAutoCompleteShipViaList = true;

      let temp_searchcriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteShipViaList;

      if (isEmpty(shipViaCode)) {
        this.state.showAutoCompleteShipViaList = false;
        let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
        let temp_searchcriteria = this.state.searchCriteria;
        temp_searchcriteria.shipViaCode = "";

        let suggestion = [];

        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: temp_searchcriteria,
          shipViaPageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && shipViaCode !== "") {
        this.readShipViaBySearchString(shipViaCode);
      }
      if (e.target.name == "shipViaCode") {
        temp_searchcriteria["shipViaCode"] = e.target.value;
        let shipViaCode_List = this.state.shipViaCodes;
        shipViaCode_List.map((shipViaCode) => {
          if (shipViaCode.code == e.target.value) {
            temp_searchcriteria["shipViaCode"] = shipViaCode.code;

            this.state.showAutoCompleteShipViaList = false;
            let showAutoCompleteList = this.state.showAutoCompleteShipViaList;
            this.setState({ showAutoCompleteList: showAutoCompleteList });
          }
        });
      }
      this.setState({ searchCriteria: temp_searchcriteria });
    };
    readShipViaBySearchString(searchString) {
      let shipViaCodeData = this.state.shipViaCodes;
      let simpleAutoCompleteList = new Array();
      if (shipViaCodeData.length > 0 && shipViaCodeData != null) {
        shipViaCodeData.map((shipViaCodeDatas) => {
          let simpleItemBean = {
            code: shipViaCodeDatas.code,
            description: shipViaCodeDatas.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;

      let filteredSuggestions = new Array();

      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompleteShipViaLists) =>
          simpleAutoCompleteShipViaLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({
        shipViaPageListForAutoCompleteList: filteredSuggestions,
      });
    }
    shipViaEnterKeyEvent = (e) => {
      let temp_searchcriteria = this.state.searchCriteria;
      let shipViaCode = e.target.value;

      temp_searchcriteria["shipViaCode"] = shipViaCode;
      let shipViaList = this.state.shipViaCodes;
      let shipViaBean = null;
      shipViaList.map((shipVia_List) => {
        if (shipVia_List.code == e.target.value) {
          shipViaBean = shipVia_List;
        }
      });
      if (!isEmpty(shipViaBean)) {
        let temp_searchcriteria = this.state.searchCriteria;
        temp_searchcriteria.shipViaCode = shipViaBean.code;

        this.setState({
          searchCriteria: temp_searchcriteria,
          shipViaPageListForAutoCompleteList: new Array(),
        });
      }
    };
    displayAutoCompleteShipViaList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteShipViaList: showAutoCompleteList });
    };
    onFOBChange = (e) => {
      let fob = e.target.value;
      this.state.showAutoCompleteFOBList = true;

      let temp_searchCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteFOBList;

      if (isEmpty(fob)) {
        this.state.showAutoCompleteFOBList = false;
        let showAutoCompleteList = this.state.showAutoCompleteFOBList;
        let temp_searchCriteria = this.state.searchCriteria;
        temp_searchCriteria.fOBCity = "";
        let suggestion = [];

        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: temp_searchCriteria,
          fobPageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && fob !== "") {
        this.readFOBBySearchString(fob);
      }
      if (e.target.name == "fOBCity") {
        temp_searchCriteria[e.target.name] = e.target.value;
        let fOBCityList = this.state.fOBCities;
        fOBCityList.map((line) => {
          if (line.code == e.target.value) {
            temp_searchCriteria["fOBCity"] = line.code;
            this.state.showAutoCompleteFOBList = false;
            let showAutoCompleteList = this.state.showAutoCompleteFOBList;
            this.setState({ showAutoCompleteFOBList: showAutoCompleteList });
          }
        });
      }

      this.setState({
        searchCriteria: temp_searchCriteria,
      });
    };
    readFOBBySearchString(searchString) {
      let fobData = this.state.fOBCities;
      let simpleAutoCompleteList = new Array();
      if (fobData.length > 0 && fobData != null) {
        fobData.map((fobs) => {
          let simpleItemBean = {
            code: fobs.code,
            description: fobs.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;

      let filteredSuggestions = new Array();

      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompleteFOBLists) =>
          simpleAutoCompleteFOBLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({ fobPageListForAutoCompleteList: filteredSuggestions });
    }
    fobEnterKeyEventHandler = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({
        searchCriteria: temp_searchCriteria,
        fobPageListForAutoCompleteList: new Array(),
      });
    };
    displayAutoCompleteShipmentTermList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteShipmentTermList: showAutoCompleteList });
    };
    displayAutoCompleteFobList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteFOBList: showAutoCompleteList });
    };
    onIncoTermChange = (e) => {
      let incoTerm = e.target.value;
      this.state.showAutoCompleteIncoTermList = true;

      let temp_searchCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteIncoTermList;

      if (isEmpty(incoTerm)) {
        this.state.showAutoCompleteIncoTermList = false;
        let showAutoCompleteList = this.state.showAutoCompleteIncoTermList;
        let temp_searchCriteria = this.state.searchCriteria;
        temp_searchCriteria.incoterm = "";
        let suggestion = [];

        this.setState({
          showAutoCompleteList: showAutoCompleteList,
          searchCriteria: temp_searchCriteria,
          incoTermPageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && incoTerm !== "") {
        this.readIncoTermBySearchString(incoTerm);
      }
      if (e.target.name == "incoterm") {
        temp_searchCriteria[e.target.name] = e.target.value;
        let incoTermList = this.state.incoTerms;
        incoTermList.map((line) => {
          if (line.code == e.target.value) {
            temp_searchCriteria["incoterm"] = line.code;
            this.state.showAutoCompleteIncoTermList = false;
            let showAutoCompleteList = this.state.showAutoCompleteIncoTermList;
            this.setState({
              showAutoCompleteIncoTermList: showAutoCompleteList,
            });
          }
        });
      }

      this.setState({
        searchCriteria: temp_searchCriteria,
      });
    };
    readIncoTermBySearchString(searchString) {
      let incoTermData = this.state.incoTerms;
      let simpleAutoCompleteList = new Array();
      if (incoTermData.length > 0 && incoTermData != null) {
        incoTermData.map((incoTerms) => {
          let simpleItemBean = {
            code: incoTerms.code,
            description: incoTerms.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;

      let filteredSuggestions = new Array();

      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompleteIncoTermLists) =>
          simpleAutoCompleteIncoTermLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({
        incoTermPageListForAutoCompleteList: filteredSuggestions,
      });
    }
    incoTermEnterKeyEventHandler = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      this.setState({
        searchCriteria: temp_searchCriteria,
        incoTermPageListForAutoCompleteList: new Array(),
      });
    };

    displayAutoCompleteIncoTermList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteIncoTermList: showAutoCompleteList });
    };
    onVendorTermChange = (e) => {
      let vendorTerm = e.target.value;
      this.state.showAutoCompleteVendorTermList = true;
      let temp_searchCriteria = this.state.searchCriteria;
      let showAutoCompleteList = this.state.showAutoCompleteVendorTermList;

      if (isEmpty(vendorTerm)) {
        this.state.showAutoCompleteVendorTermList = false;
        let showAutoCompleteList = this.state.showAutoCompleteVendorTermList;
        let temp_searchCriteria = this.state.searchCriteria;
        temp_searchCriteria.buyingTermsCode = "";
        let suggestion = [];

        this.setState({
          showAutoCompleteVendorTermList: showAutoCompleteList,
          searchCriteria: temp_searchCriteria,
          vendorTermPageListForAutoCompleteList: suggestion,
        });
      } else if (showAutoCompleteList === true && vendorTerm !== "") {
        this.readVendorTermBySearchString(vendorTerm);
      }
      if (e.target.name == "buyingTermsCode") {
        temp_searchCriteria[e.target.name] = e.target.value;
        let buyingTermsCodeList = this.state.vendorTerms;
        buyingTermsCodeList.map((line) => {
          if (line.code == e.target.value) {
            temp_searchCriteria["buyingTermsCode"] = line.code;
            this.state.showAutoCompleteVendorTermList = false;
            let showAutoCompleteList =
              this.state.showAutoCompleteVendorTermList;
            this.setState({
              showAutoCompleteVendorTermList: showAutoCompleteList,
            });
          }
        });
      }

      this.setState({
        searchCriteria: temp_searchCriteria,
      });
    };

    readVendorTermBySearchString(searchString) {
      let vendorTermData = this.state.vendorTerms;
      let simpleAutoCompleteList = new Array();
      if (vendorTermData.length > 0 && vendorTermData != null) {
        vendorTermData.map((vendorTerms) => {
          let simpleItemBean = {
            code: vendorTerms.code,
            description: vendorTerms.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      let userInput = searchString;

      let filteredSuggestions = new Array();

      filteredSuggestions = simpleAutoCompleteList.filter(
        (simpleAutoCompleteVendorTermLists) =>
          simpleAutoCompleteVendorTermLists.code
            .toLowerCase()
            .indexOf(userInput.toLowerCase()) > -1
      );
      this.setState({
        vendorTermPageListForAutoCompleteList: filteredSuggestions,
      });
    }
    vendorTermEnterKeyEventHandler = (e) => {
      let temp_searchCriteria = this.state.searchCriteria;
      temp_searchCriteria[e.target.name] = e.target.value;
      let vendorTermCode_List = this.state.vendorTerms;
      let vendorTermCodeBean = null;
      vendorTermCode_List.map((ln) => {
        if (ln.code == e.target.value) {
          vendorTermCodeBean = ln;
        }
      });
      if (!isEmpty(vendorTermCodeBean)) {
        temp_searchCriteria.buyingTermsCode = vendorTermCodeBean.code;

        this.setState({
          searchCriteria: temp_searchCriteria,
          vendorTermPageListForAutoCompleteList: new Array(),
        });
      }
    };
    displayAutoCompleteBuyingTermsList = (showAutoCompleteList) => {
      this.setState({ showAutoCompleteVendorTermList: showAutoCompleteList });
    };
    render() {
      let searchCriteria = this.state.searchCriteria;
      return (
        <div>
          <Container onKeyDown={this.onContainerKeyDown}>
            <Row>
              <Col sm={5}>
                <FormLabel>VendorCode</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="vendorCode"
                  name="vendorCode"
                  onChange={this.onChange}
                  value={searchCriteria.vendorCode}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>VendorCode StartsWith</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="vendorCodeStartsWith"
                  name="vendorCodeStartsWith"
                  onChange={this.onChange}
                  value={searchCriteria.vendorCodeStartsWith}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>VendorCode Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="vendorCodeContains"
                  name="vendorCodeContains"
                  onChange={this.onChange}
                  value={searchCriteria.vendorCodeContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>VendorName Contains</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="vendorNameContains"
                  name="vendorNameContains"
                  onChange={this.onChange}
                  value={searchCriteria.vendorNameContains}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Active</FormLabel>
              </Col>
              <Col sm={7}>
                <FormControl
                  as="select"
                  custom
                  onChange={this.onChange}
                  name="status"
                  value={searchCriteria.status}
                >
                  <option value={""}></option>
                  <option value={"I"}>InActive</option>
                  <option value={"A"}>Active</option>
                </FormControl>
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Buying Terms</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="buyingTermsCode"
                  name="buyingTermsCode"
                  onChange={this.onVendorTermChange}
                  value={searchCriteria.buyingTermsCode}
                  lookupRequired={true}
                  lookupHandler={this.state.vendorTermLookupHandler}
                  enterKeyEventHandler={this.vendorTermEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.vendorTermPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayAutoCompleteBuyingTermsList
                  }
                  showAutoCompleteList={
                    this.state.showAutoCompleteVendorTermList
                  }
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Vendor Category</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="VendorCategory"
                  name="vendorCategoryCode"
                  onChange={this.onChange}
                  value={searchCriteria.vendorCategoryCode}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>ShipVia</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="ShipVia"
                  name="shipViaCode"
                  onChange={this.onShipViaChange}
                  value={searchCriteria.shipViaCode}
                  lookupRequired={true}
                  lookupHandler={this.state.shipViaLookupHandler}
                  enterKeyEventHandler={this.shipViaEnterKeyEvent}
                  autoCompleteListData={
                    this.state.shipViaPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteShipViaList}
                  showAutoCompleteList={this.state.showAutoCompleteShipViaList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>FOB City</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="fOBCity"
                  name="fOBCity"
                  onChange={this.onFOBChange}
                  value={searchCriteria.fOBCity}
                  lookupRequired={true}
                  lookupHandler={this.state.fobCityLookupHandler}
                  enterKeyEventHandler={this.fobEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.fobPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteFobList}
                  showAutoCompleteList={this.state.showAutoCompleteFOBList}
                />
              </Col>
            </Row>
            <Row>
              <Col sm={5}>
                <FormLabel>Incoterm</FormLabel>
              </Col>
              <Col sm={7}>
                <InputTextbox
                  id="incoterm"
                  name="incoterm"
                  onChange={this.onIncoTermChange}
                  value={searchCriteria.incoterm}
                  lookupRequired={true}
                  lookupHandler={this.state.incoTermLookupHandler}
                  enterKeyEventHandler={this.incoTermEnterKeyEventHandler}
                  autoCompleteListData={
                    this.state.incoTermPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteIncoTermList}
                  showAutoCompleteList={this.state.showAutoCompleteIncoTermList}
                />
              </Col>
            </Row>
            <div className="popup_criteria_button_align-lookup">
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.continueButtonClick}
                ref={this.focusRef}
              >
                <TickIcon />
                Continue
              </Button>
              <Button
                className="header_buttons btn btn-primary btn-sm enterFocus"
                onClick={this.clearCriteria}
              >
                <Eraser />
                Clear
              </Button>
            </div>
          </Container>
        </div>
      );
    }
  };
};
